import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { bool } from 'prop-types';
import cn from 'classnames';

import SmartbannerContext from '~screens/Commerce/contexts/SmartbannerContext/context';

import styles from './styles.module.scss';
import { TEMPLATE_MODEL_COMPONENTS } from './constants';
import { getAllComps } from './utils';

const Navbar = ({ topSiteMessage }) => {
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const { templateModel } = useSelector((state) => state.core);

  const templateConfig = TEMPLATE_MODEL_COMPONENTS[templateModel];
  const containerClassName = templateConfig.alignmentClassName;
  const components = getAllComps(templateConfig);
  const { isSmartbannerActive } = useContext(SmartbannerContext);

  return (
    <nav
      id="navbarTop"
      className={cn(styles[`navBar${templateModel}`], {
        [styles.topSiteMessage]: topSiteMessage,
        [styles.smartbannerActive]: isSmartbannerActive,
        [styles.secondaryHeader]: isSecondaryHeader
      })}>
      <div className={`${containerClassName} ${styles.containerNavBar}`}>
        {components.map(
          (comp) =>
            comp && (
              <comp.component
                key={comp.name}
                className={comp.className}
                templateModel={templateModel}
                {...comp.props}
              />
            )
        )}
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  isSmartbannerOpen: bool,
  topSiteMessage: bool
};

Navbar.defaultProps = {
  isSmartbannerOpen: false,
  topSiteMessage: false
};

export default Navbar;
